import React from 'react';
import { ThemeContext } from '../../../components/theme/Theme.jsx';
import radium from 'radium';
import { connect } from 'react-redux';
import { setTicketAddress } from '../../../redux/ticketAddressReducer';

// Styles
import './TakeOverShippingAddress.scss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function TakeOverShippingAddress(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		icon: {
			fontSize: context.themeManager.value('ticket-address', 'takeOverIconFontSize', 'font-size-100'),
			color: context.themeManager.value('ticket-address', 'takeOverIconColor', 'fg-color-icon-highlight'),
		},
		actionName: {
			color: context.themeManager.value('ticket-address', 'takeOverLinkColor', 'fg-color-icon-highlight'),
			fontSize: context.themeManager.value('ticket-address', 'takeOverLinkFontSize', 'font-size-100'),
		},
	};
	return (
		<button className="leo__button-sample take-over-link__container" onClick={() => props.onTakeOverLinkClicked(props.shipmentAddress)} name={"Versandadresse übernehmen"}>
			<div className="take-over-link__icon">
				<FontAwesomeIcon
					icon="copy"
					style={style.icon}
				/>
			</div>
			<div style={style.actionName}>Versandadresse übernehmen</div>
		</button>
	);
}

const RadiumTakeOverShippingAddress = radium(TakeOverShippingAddress);

// ------------------------------
// Redux Connection
// ------------------------------
const mapStateToProps = (state) => {
	const shipmentAddress = state.customer.shipmentAddress;
	return {
		shipmentAddress,
	};
};
const mapDispatchToProps = (dispatch, ownProps) => ({
	onTakeOverLinkClicked: (shipmentAddress) => {
		/* we will probably need a validation if the shipping address
		and ticket address have the same fields.
		E.g. "function" doesn't exist at TicketAddress. */
		const clonedAddress = Object.assign({}, shipmentAddress);
		/** do not copy additional Info from shipment address to ticket address */
		delete clonedAddress.additionalInfo;
		dispatch(setTicketAddress(clonedAddress, ownProps.ticketItemUuid));
	},
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(RadiumTakeOverShippingAddress);
